export const INCREMENT = "INCREMENT"
export const DECREMENT = "DECREMENT"
export const CONTROL_LOADING = "CONTROL_LOADING"
export const CONTROL_DECLARATION = "CONTROL_DECLARATION"
export const UPDATE_CATEGORY_CLAIM_DATA = "UPDATE_CATEGORY_CLAIM_DATA"
export const UPDATE_DESC_OF_DAMAGE_CHECK_BOX = "UPDATE_DESC_OF_DAMAGE_CHECK_BOX"
export const UPDATE_DESC_DAMAGE_VALUE = "UPDATE_DESC_DAMAGE_VALUE"
export const CONTROL_EDIT_BENEFIT = "CONTROL_EDIT_BENEFIT"
export const SAVE_DATA_FROM_API = "SAVE_DATA_FROM_API"
export const FORM_IS_VALID_UPDATE = "FORM_IS_VALID_UPDATE"
export const PAGE_CLICKED_NEXT_UPDATE = "PAGE_CLICKED_NEXT_UPDATE"
export const GENERATE_FOLDER_NAME = "GENERATE_FOLDER_NAME"
export const SELECT_DOCUMENT = "SELECT_DOCUMENT"
export const RESET_SELECT_DOCUMENT = "RESET_SELECT_DOCUMENT"
export const ADD_FILE_TO_LIST = "ADD_FILE_TO_LIST"
export const REMOVE_FILE_FROM_LIST = "REMOVE_FILE_FROM_LIST"
export const STORE_DOCUMENT_LIST = "STORE_DOCUMENT_LIST"
export const UPDATE_POLICE_REPORT_MANDATORY = "UPDATE_POLICE_REPORT_MANDATORY"
export const EDIT_UPLOAD = "EDIT_UPLOAD"
export const EDIT_ALL_INVALID_FORM = "EDIT_ALL_INVALID_FORM"
export const CHECKBOX_STATUS_UPDATE = "CHECKBOX_STATUS_UPDATE"
export const UPDATE_SUBMIT_STATUS = "UPDATE_SUBMIT_STATUS"
export const UPDATE_UI_DATA = "UPDATE_UI_DATA"

export const increment = () => {
  return {
    type: INCREMENT,
  }
}

export const decrement = () => {
  return {
    type: DECREMENT,
  }
}

export const controlLoading = () => {
  return {
    type: CONTROL_LOADING,
  }
}

export const controlDeclaration = () => {
  return {
    type: CONTROL_DECLARATION,
  }
}

export const updateCategoryClaimData = (
  category,
  coverageCode,
  inputName,
  inputValue
) => {
  return {
    type: UPDATE_CATEGORY_CLAIM_DATA,
    category: category,
    coverageCode: coverageCode,
    name: inputName,
    value: inputValue,
  }
}

export const formIsValidUpdate = (formName, status) => {
  return {
    type: FORM_IS_VALID_UPDATE,
    formName: formName,
    status: status,
  }
}

export const updateDescOfDamageCheckBox = textDesc => {
  return {
    type: UPDATE_DESC_OF_DAMAGE_CHECK_BOX,
    textDesc: textDesc,
  }
}

export const updateDescDamageValue = (textDesc, buttonValue) => {
  return {
    type: UPDATE_DESC_DAMAGE_VALUE,
    textDesc: textDesc,
    buttonValue: buttonValue,
  }
}

export const controlEditBenefit = formName => {
  return {
    type: CONTROL_EDIT_BENEFIT,
    formName: formName,
  }
}

export const saveDataFromAPI = (targetName, apiResultList) => {
  return {
    type: SAVE_DATA_FROM_API,
    targetName: targetName,
    apiResultList: apiResultList,
  }
}

export const updateClickedNext = pageClickedNext => {
  return {
    type: PAGE_CLICKED_NEXT_UPDATE,
    pageClickedNext,
  }
}

export const generateFolderName = () => {
  return {
    type: GENERATE_FOLDER_NAME,
  }
}

export const selectDocument = (documentId, documentDesc) => {
  return {
    type: SELECT_DOCUMENT,
    documentId: documentId,
    documentDesc: documentDesc,
  }
}

export const resetSelectDocument = () => {
  return {
    type: RESET_SELECT_DOCUMENT,
  }
}

export const addFileToList = (
  fileName,
  documentId,
  filePath,
  fileSize,
  folderName,
  compressedFilesize
) => {
  return {
    type: ADD_FILE_TO_LIST,
    fileName: fileName,
    documentId: documentId,
    filePath: filePath,
    fileSize: fileSize,
    folderName: folderName,
    compressedFilesize: compressedFilesize,
  }
}

export const removeFileFromList = (fileName, fileSize) => {
  return {
    type: REMOVE_FILE_FROM_LIST,
    fileName: fileName,
    fileSize: fileSize,
  }
}

export const storeDocumentList = apiResponseData => {
  return {
    type: STORE_DOCUMENT_LIST,
    apiResponseData: apiResponseData,
  }
}

export const updatePoliceReportMandatory = updatedValue => {
  return {
    type: UPDATE_POLICE_REPORT_MANDATORY,
    updatedValue,
  }
}

export const editUpload = () => {
  return {
    type: EDIT_UPLOAD,
  }
}

export const editAllInvalidForm = formlist => {
  return {
    type: EDIT_ALL_INVALID_FORM,
    formlist,
  }
}

export const checkboxStatusUpdate = checkboxName => {
  return {
    type: CHECKBOX_STATUS_UPDATE,
    checkboxName: checkboxName,
  }
}

export const receivedSubmitStatus = claimID => {
  return {
    type: UPDATE_SUBMIT_STATUS,
    claimID,
  }
}

export const updateUiData = (property, newData) => {
  return {
    type: UPDATE_UI_DATA,
    property,
    newData,
  }
}